import { ProductMenu } from '../product-menu';
import { CardsThatLayoutOntoPaper } from '../section/cards-that-layout-onto-paper';
import { PaperSize } from '../../shared/paper-size';

export abstract class LaysOutCardsOnToPaperMenu extends ProductMenu {
  protected abstract forceSectionType(section: CardsThatLayoutOntoPaper): void;

  public override displaySize: PaperSize;
  public override template?: LaysOutCardsOnToPaperMenu;
  public override sections: CardsThatLayoutOntoPaper[];
  public override templateSections: CardsThatLayoutOntoPaper[];

  protected override deserializeDisplaySize(): void {
    this.displaySize = window?.injector?.Deserialize?.instanceOf(PaperSize, this.displaySize);
  }

  protected setCardInfoDataOnSection(section: CardsThatLayoutOntoPaper): void {
    const isTemplatedMenu = this.isTemplatedMenu();
    this.forceSectionType(section);
    this.setSectionSingleCardPerPage(isTemplatedMenu, section);
    this.setSectionPaperSize(isTemplatedMenu, section);
    this.setSectionCardSize(isTemplatedMenu, section);
    this.setSectionOrientation(isTemplatedMenu, section);
    this.setSectionThemeId(isTemplatedMenu, section);
  }

  protected setSectionSingleCardPerPage(isTemplatedMenu: boolean, section: CardsThatLayoutOntoPaper): void {
    section.singleCardPerPage = isTemplatedMenu
      ? this.menuOptions?.singlePageMenu || this.template?.menuOptions?.singlePageMenu || false
      : this.menuOptions?.singlePageMenu || false;
  }

  protected setSectionPaperSize(isTemplatedMenu: boolean, section: CardsThatLayoutOntoPaper): void {
    section.paperSize = isTemplatedMenu
      ? this.displaySize?.name || this.template?.displaySize?.name
      : this.displaySize?.name;
  }

  protected setSectionCardSize(isTemplatedMenu: boolean, section: CardsThatLayoutOntoPaper): void {
    section.cardSize = isTemplatedMenu
      ? this.metadata?.printCardSize || this.template?.metadata?.printCardSize
      : this.metadata?.printCardSize;
  }

  protected setSectionOrientation(isTemplatedMenu: boolean, section: CardsThatLayoutOntoPaper): void {
    section.orientation = isTemplatedMenu
      ? this.hydratedTheme?.printConfig?.cardOrientationMap?.get(section?.cardSize) ||
        this.template?.hydratedTheme?.printConfig?.cardOrientationMap?.get(section?.cardSize)
      : this.hydratedTheme?.printConfig?.cardOrientationMap?.get(section?.cardSize);
  }

  protected setSectionThemeId(isTemplatedMenu: boolean, section: CardsThatLayoutOntoPaper): void {
    section.themeId = isTemplatedMenu ? this.theme || this.template?.theme : this.theme;
  }

  /**
   * This was added to accommodate stacks being able to have multiple card sizes.
   * In that case, each section would represent a different card size.
   * For menus that don't support multiple card sizes per stack, just return the first section.
   */
  getLayoutInstructions(): CardsThatLayoutOntoPaper[] {
    const instructions = this.sections?.firstOrNull();
    return instructions ? [instructions] : [];
  }
}
